import { compose, mdsWidget } from 'dojo/_base/declare';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import AttachmentUpload from './AttachmentUpload';
import template from './templates/AttachmentList.html?raw';
import domConstructTyped from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
// NOTE (JS2TS): dropped dead dojo dep (_base/connect). DOM-heavy → dom-construct aliased to any.

const domConstruct: any = domConstructTyped;

class AttachmentList extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;
    item: any = null;
    externalButton: any = null;
    jsonEntitylist: any = null;
    attachmentUpload: any = null;
    _displayMode = 1;
    _tables: any = [];

    startup(): void {

        //domClass.remove(this.showBtn, "w3-hide");
        domClass.remove(this.menuBtn, "w3-hide");
        domClass.remove(this.reloadBtn, "w3-hide");
        if (this.item.LvlAttachmentList > 50) {
            domClass.remove(this.newBtn, "w3-hide");
        }
        this.loadAttachments();
    }

    loadAttachments(): void {

        //spinners.global().spin(document.getElementById('spinner_box'));
        this.StandbyStart();

        domConstruct.empty(this.tableNode);
        domClass.remove(this.tableNode);

        var url = window.appRoot + "SOV/AttachmentsGetAttachmentsOfProject";
        //var url = window.appRoot + "Orchestra/GetOtherMusiciansDispo";

        this.RequestManager.post(
            url,
            {
                associateID: this.item.ref_associate,
                projectID: this.item.ref_ev_project
            },
            lang.hitch(this, "_onloadAttachmentsResponse"),
            lang.hitch(this, "_onloadAttachmentsError"),
            false // sync
        );
    }

    _onloadAttachmentsResponse(response: any): void {
        var jsonResponse = JSON.parse(response);
        console.log("_onloadAttachmentsResponse", jsonResponse);

        this._tables = [];

        var jsonEntitylist = jsonResponse.HtFiles;

        // Block mit den ht-files
        {
            // Tabelle erzeugen....
            var table = domConstruct.create("table");
            domClass.add(table, "w3-hide");
            domStyle.set(table, "margin-bottom", "0");
            domConstruct.place(table, this.tableNode);

            var thead = domConstruct.create("thead");
            domConstruct.place(thead, table);

            var row = domConstruct.create("tr");
            domConstruct.place(row, thead);

            // Spalten mit den Überschriften
            var col = domConstruct.create("td");
            domConstruct.place(col, row);
            domAttr.set(col, "innerHTML", "Datei");

            col = domConstruct.create("td");
            domConstruct.place(col, row);
            domAttr.set(col, "innerHTML", "letzte Änderung");

            col = domConstruct.create("td");
            domConstruct.place(col, row);
            domAttr.set(col, "innerHTML", "Größe (kB)");
            domClass.add(col, "w3-right-align");

            var tbody = domConstruct.create("tbody");
            domConstruct.place(tbody, table);

            if (jsonEntitylist.length == 0) {
                var row = domConstruct.create("tr");
                domConstruct.place(row, thead);

                // Spalten mit den Überschriften
                var col = domConstruct.create("td");
                domAttr.set(col, "colspan", "3");
                domConstruct.place(col, row);
                domClass.add(col, "w3-center");
                domAttr.set(col, "innerHTML", "<i>keine Einträge</i>");
            }

            for (var i = 0; i < jsonEntitylist.length; i++) {
                var entity = jsonEntitylist[i];

                //var color = entity.ref_webform_travelexpense_status.tmp_hex_color.split(":");

                row = domConstruct.create("tr");
                domConstruct.place(row, tbody);

                //domStyle.set(row, "background-color", "#" + color[0]);
                //domStyle.set(row, "color", "#" + color[1]);

                col = domConstruct.create("td");
                domConstruct.place(col, row);
                domStyle.set(col, "padding", 0);
                domClass.add(col, "w3-cell w3-cell-middle");

                // button und icon erzeugen für download
                var outerDiv = domConstruct.create("a");
                domConstruct.place(outerDiv, col);
                domClass.add(outerDiv, "w3-button");

                on(outerDiv, "click", lang.hitch(this, "downloadFile", entity.ID));

                var iconDiv = domConstruct.create("div", {}, outerDiv);
                domClass.add(iconDiv, "w3-cell");
                domAttr.set(iconDiv, "innerHTML", "<i class=\"fa fa-download\" aria-hidden=\"true\">&nbsp;</i>");

                var innerDiv = domConstruct.create("div", {}, outerDiv);
                domClass.add(innerDiv, "w3-cell w3-left-align");
                domStyle.set(innerDiv, "white-space", "normal");

                domAttr.set(innerDiv, "innerHTML", entity.ref_vt_file.tmp_actual_filename);

                // Datum parsen und formatieren
                var optionsDate: any = { year: 'numeric', month: '2-digit', day: '2-digit' };
                var optionsTime: any = { hour: '2-digit', minute: '2-digit' };
                var date: any = entity.ref_vt_file.file_modification_date;
                if (typeof (date) == "string") {
                    date = new Date(entity.ref_vt_file.file_modification_date);
                }

                col = domConstruct.create("td");
                domConstruct.place(col, row);
                domClass.add(col, "w3-cell w3-cell-middle");

                if (typeof (date) == "object") {
                    domAttr.set(col, "innerHTML", date.toLocaleDateString("de-AT", optionsDate) + " " + date.toLocaleTimeString("de-AT", optionsTime));
                }


                col = domConstruct.create("td");
                domConstruct.place(col, row);
                domAttr.set(col, "innerHTML", entity.ref_vt_file.tmp_filesize_kb);
                domClass.add(col, "w3-right-align");
                domClass.add(col, "w3-cell w3-cell-middle");


            }

            this._tables.push(table);
        }
        // Block mit den Upload-Datensätzen
        {
            jsonEntitylist = jsonResponse.WebformUploads;

            // Tabelle erzeugen....
            var table = domConstruct.create("table");
            domClass.add(table, "w3-hide");
            domStyle.set(table, "margin-bottom", "0");
            domConstruct.place(table, this.tableNode);

            var thead = domConstruct.create("thead");
            domConstruct.place(thead, table);

            var row = domConstruct.create("tr");
            domConstruct.place(row, thead);

            // Spalten mit den Überschriften
            var col = domConstruct.create("td");
            domConstruct.place(col, row);
            domAttr.set(col, "innerHTML", "Datei");

            col = domConstruct.create("td");
            domConstruct.place(col, row);
            domAttr.set(col, "innerHTML", "Anmerkung");

            col = domConstruct.create("td");
            domConstruct.place(col, row);
            domAttr.set(col, "innerHTML", "hochgeladen am");

            col = domConstruct.create("td");
            domConstruct.place(col, row);
            domAttr.set(col, "innerHTML", "Größe (kB)");
            domClass.add(col, "w3-right-align");

            var tbody = domConstruct.create("tbody");
            domConstruct.place(tbody, table);

            if (jsonEntitylist.length == 0) {
                var row = domConstruct.create("tr");
                domConstruct.place(row, thead);

                // Spalten mit den Überschriften
                var col = domConstruct.create("td");
                domAttr.set(col, "colspan", "4");
                domConstruct.place(col, row);
                domClass.add(col, "w3-center");
                domAttr.set(col, "innerHTML", "<i>keine Einträge</i>");
            }

            for (var i = 0; i < jsonEntitylist.length; i++) {
                var entity = jsonEntitylist[i];

                //var color = entity.ref_webform_travelexpense_status.tmp_hex_color.split(":");

                row = domConstruct.create("tr");
                domConstruct.place(row, tbody);

                //domStyle.set(row, "background-color", "#" + color[0]);
                //domStyle.set(row, "color", "#" + color[1]);

                col = domConstruct.create("td");
                domConstruct.place(col, row);
                domStyle.set(col, "padding", 0);
                domClass.add(col, "w3-cell w3-cell-middle");

                // button und icon erzeugen für download
                var outerDiv = domConstruct.create("a");
                domConstruct.place(outerDiv, col);
                domClass.add(outerDiv, "w3-button");

                on(outerDiv, "click", lang.hitch(this, "downloadFile", entity.ID));

                var iconDiv = domConstruct.create("div", {}, outerDiv);
                domClass.add(iconDiv, "w3-cell");
                domAttr.set(iconDiv, "innerHTML", "<i class=\"fa fa-download\" aria-hidden=\"true\">&nbsp;</i>");

                var innerDiv = domConstruct.create("div", {}, outerDiv);
                domClass.add(innerDiv, "w3-cell w3-left-align");
                domStyle.set(innerDiv, "white-space", "normal");

                domAttr.set(innerDiv, "innerHTML", entity.original_filename);


                col = domConstruct.create("td");
                domConstruct.place(col, row);
                domClass.add(col, "w3-cell w3-cell-middle");
                domAttr.set(col, "innerHTML", entity.note_uploader.replace("\r\n", "<br>"));


                // Datum parsen und formatieren
                var optionsDate: any = { year: 'numeric', month: '2-digit', day: '2-digit' };
                var optionsTime: any = { hour: '2-digit', minute: '2-digit' };
                var date: any = entity.CreationDate;
                if (typeof (date) == "string") {
                    date = new Date(entity.CreationDate);
                }

                col = domConstruct.create("td");
                domConstruct.place(col, row);
                domClass.add(col, "w3-cell w3-cell-middle");

                if (typeof (date) == "object") {
                    domAttr.set(col, "innerHTML", date.toLocaleDateString("de-AT", optionsDate) + " " + date.toLocaleTimeString("de-AT", optionsTime));
                }

                col = domConstruct.create("td");
                domConstruct.place(col, row);
                domAttr.set(col, "innerHTML", entity.tmp_filesize_kb);
                domClass.add(col, "w3-right-align");
                domClass.add(col, "w3-cell w3-cell-middle");
            }

            this._tables.push(table);
        }

        //spinners.global().stop();
        this.StandbyStop();

        if (this.externalButton != null) {
            domClass.add(this.externalButton, "w3-hide");
        }

        this.showSelectedTable();
        this._setMenuOptionsStyle();
        this._onClickShow();

    }

    _onloadAttachmentsError(error: any): void {
        console.log("_onloadAttachmentsError", error);
        //spinners.global().stop();
        this.StandbyStop();
    }

    showSelectedTable(): void {
        var index = this._displayMode - 1;

        if (index > this._tables.length) {
            return;
        }

        for (var i = 0; i < this._tables.length; i++) {
            if (i == index) {
                domClass.remove(this._tables[i], "w3-hide");
            } else {
                domClass.add(this._tables[i], "w3-hide");
            }
        }

    }

    _onClickHide(evt: any): void {
        domClass.add(this.tableNode, "w3-hide");
    }

    _onClickShow(evt?: any): void {
        domClass.remove(this.reloadBtn, "w3-hide");


    }

    _onClickReload(evt?: any): void {
        this.loadAttachments();
    }

    _onClickMenu(evt: any): void {
        if (domClass.contains(this.menuContent, "w3-hide")) {
            this.menuOpen();
        } else {
            this.menuClose();
        }
    }

    _onClickOpt_htFiles(evt: any): void {
        this._displayMode = 1;
        this._setMenuOptionsStyle();

        this.showSelectedTable();

        this.menuClose();
        evt.stopPropagation();
    }

    _onClickOpt_webformUploads(evt: any): void {
        this._displayMode = 2;
        this._setMenuOptionsStyle();

        this.showSelectedTable();

        this.menuClose();
        evt.stopPropagation();
    }

    _setMenuOptionsStyle(): void {
        domClass.remove(this.opt_htFiles, "w3-button w3-light-gray");
        domStyle.set(this.opt_htFiles, "font-weight", "normal");

        domClass.remove(this.opt_webformUploads, "w3-button w3-light-gray");
        domStyle.set(this.opt_webformUploads, "font-weight", "normal");

        if (this._displayMode == 1) { // ht-file, allgemein freigegebene Dateien
            domClass.add(this.opt_htFiles, "w3-light-gray")
            domStyle.set(this.opt_htFiles, "font-weight", "bold");

            domClass.add(this.opt_webformUploads, "w3-button");

            domAttr.set(this.menuLabel, "innerHTML", domAttr.get(this.opt_htFiles, "innerHTML"));
        } else if (this._displayMode == 2) { // webformUploads, meine uploads die noch nicht zu richtigen Files gemacht worden sind in evis
            domClass.add(this.opt_webformUploads, "w3-light-gray")
            domStyle.set(this.opt_webformUploads, "font-weight", "bold");

            domClass.add(this.opt_htFiles, "w3-button");

            domAttr.set(this.menuLabel, "innerHTML", domAttr.get(this.opt_webformUploads, "innerHTML"));
        }
    }

    menuOpen(): void {
        domClass.remove(this.menuContent, "w3-hide");
    }

    menuClose(): void {
        domClass.add(this.menuContent, "w3-hide");
    }

    _onClickNew(evt: any): void {
        if (this.attachmentUpload == null) {
            this.attachmentUpload = new AttachmentUpload();

            this.attachmentUpload.item = this.item;

            this.attachmentUpload.submitCallback = lang.hitch(this, "uploadResponse");

            domAttr.set(this.headerNode, "innerHTML", "neue Datei hochladen - " + this.item.ProjectDescription);

            domConstruct.place(this.attachmentUpload.domNode, this.modalContentNode);

            this.attachmentUpload.startup();
        }

        domStyle.set(this.modalDlg, "display", "block");
    }

    _onClick_Modal_Close(evt?: any): void {
        domStyle.set(this.modalDlg, "display", "none");

        this.attachmentUpload.destroy(); // optional?
        this.attachmentUpload = null;
    }

    downloadFile(attID: any, evt?: any): void {
        //console.log("downloadFile", evt, attID);
        var url = window.appRoot + "SOV/AttachmentsFileDownload?HtFileId=" + attID;
        window.open(url);
    }

    uploadResponse(): void {
        this._onClick_Modal_Close();
        this._onClickReload();
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

}
AttachmentList.prototype.declaredClass = 'WidgetCollection.SOV.legacy.Main.AttachmentList';

export default mdsWidget(AttachmentList);
